import Text from './Text';
import Boolean from "./Boolean";
import Select from "./Select";
import DateRange from "./DateRange";

import "./OverviewTableFilters.css";

const OverviewTableFilters = {};

OverviewTableFilters.Text = Text;
OverviewTableFilters.DateRange = DateRange;
OverviewTableFilters.Boolean = Boolean;
OverviewTableFilters.Select = Select;

export default OverviewTableFilters;